import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f90d495"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "filters double" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Filters", -1 /* HOISTED */))
const _hoisted_5 = { class: "filter-container double" }
const _hoisted_6 = {
  key: 0,
  class: "no-filters"
}
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 22 20",
  x: "175",
  y: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.7 3.6l.6.6 1-1 .9.9-1 1 .6.6L18 4.5c.3-.3.3-.7 0-1l-1.2-1.2c-.3-.3-.7-.3-1 0l-1.1 1.3zM15.2 6.2l-7.5 7.6-1-1 7.6-7.5-.6-.7-8.3 8.3 2.2 2.2 8.3-8.2zM6.4 16.3l-2.9.7.8-2.9z",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  x: "305",
  y: "75"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 6h-1v7h1V6zm-2 0H9v7h1V6zm4.02-4H12V1a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H3v1h1v13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V3h1V2h-1.98zM8 1h3.02v1H8V1zm6 15H5V3h9v13zM8 6H7v7h1V6z",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  id: "shared_asset_images_tooltip_Tooltip_Action_Down_Active",
  x: "420"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    fill: "currentColor",
    d: "M10 7H8V5H7v2H5v1h2v2h1V8h2z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 2H3c-.5 0-1 .5-1 1v9c0 .5.5 1 1 1h9c.5 0 1-.5 1-1V3c0-.5-.5-1-1-1zm0 10H3V3h9v9z",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add the currently active supported filters", -1 /* HOISTED */))
const _hoisted_16 = { class: "iteration-filter double" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = {
  key: 0,
  class: "no-if"
}
const _hoisted_19 = { class: "check" }
const _hoisted_20 = { class: "check" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TableauPopup"], {
    ref: "popup",
    width: 460,
    title: "Advanced Export",
    submitText: "Export",
    status: $setup.status,
    statusMessage: $setup.statusMessage,
    canSubmit: $setup.canExport,
    onSubmitted: $setup.doExport,
    statusLink: $setup.cancelLinkInfo
  }, {
    default: _withCtx(() => [
      _createVNode($setup["TableauRadioButton"], {
        groupName: "exportType",
        value: "simple",
        text: "Quick Export",
        disabled: !$props.screenshot || $setup.status === 'loading',
        modelValue: $setup.state.exportType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.exportType) = $event))
      }, null, 8 /* PROPS */, ["disabled", "modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(["desc radio simple", { disabled: $setup.status === 'loading' }])
      }, " Exports an image of the Dashboard as it is displayed currently ", 2 /* CLASS */),
      _createVNode($setup["TableauRadioButton"], {
        groupName: "exportType",
        value: "advanced",
        text: "Detailed Export",
        disabled: $setup.status === 'loading',
        modelValue: $setup.state.exportType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.exportType) = $event))
      }, null, 8 /* PROPS */, ["disabled", "modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(["desc radio", { disabled: $setup.status === 'loading' }])
      }, [
        _createTextVNode(" Exports an image or PDF with extra filter/layout configuration"),
        _hoisted_1,
        _createTextVNode("NOTE: The currently applied filters are not applied unless manually added below in the 'Filters' section ")
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", {
          class: _normalizeClass({ disabled: $setup.advancedControlsDisabled })
        }, "Views to export:", 2 /* CLASS */),
        _createVNode($setup["TableauSelect"], {
          placeholder: "Select Views",
          multiSelect: "",
          disabled: $setup.advancedControlsDisabled,
          getItems: $setup.getViewList,
          modelValue: $setup.state.selectedViewIds,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.selectedViewIds) = $event))
        }, null, 8 /* PROPS */, ["disabled", "modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: _normalizeClass(["title", { disabled: $setup.advancedControlsDisabled }])
          }, [
            _hoisted_4,
            _createElementVNode("div", {
              class: _normalizeClass(["desc", { disabled: $setup.advancedControlsDisabled }])
            }, " Only single-value categorical filters are allowed ", 2 /* CLASS */)
          ], 2 /* CLASS */),
          _createVNode($setup["TableauButton"], {
            class: "add",
            text: "Add Filter",
            disabled: $setup.advancedControlsDisabled,
            color: "secondary",
            onClicked: _cache[3] || (_cache[3] = ($event: any) => ($setup.editFilter()))
          }, null, 8 /* PROPS */, ["disabled"]),
          _createElementVNode("div", _hoisted_5, [
            ($setup.state.filters.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("label", {
                    class: _normalizeClass({ disabled: $setup.advancedControlsDisabled })
                  }, "No filters are configured", 2 /* CLASS */),
                  _createVNode($setup["TableauLink"], {
                    onClick: _withModifiers($setup.addCurrentFilters, ["stop","prevent"]),
                    disabled: $setup.advancedControlsDisabled || $setup.addingCurrentFilters
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Use the currently active supported filters")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick", "disabled"])
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.filters, (filter) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "filter-control",
                key: filter.name
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["content", { disabled: $setup.advancedControlsDisabled }])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["title name", { disabled: $setup.advancedControlsDisabled }])
                  }, "Name: ", 2 /* CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text name", { disabled: $setup.advancedControlsDisabled }])
                  }, _toDisplayString(filter.name), 3 /* TEXT, CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(["title value", { disabled: $setup.advancedControlsDisabled }])
                  }, " Value: ", 2 /* CLASS */),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text value", { disabled: $setup.advancedControlsDisabled }])
                  }, _toDisplayString(filter.value), 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["edit", { disabled: $setup.advancedControlsDisabled }]),
                    disabled: $setup.advancedControlsDisabled,
                    onClick: _withModifiers(($event: any) => ($setup.editFilter(filter)), ["stop","prevent"])
                  }, _hoisted_10, 10 /* CLASS, PROPS */, _hoisted_8),
                  _createElementVNode("button", {
                    class: _normalizeClass(["delete", { disabled: $setup.advancedControlsDisabled }]),
                    disabled: $setup.advancedControlsDisabled,
                    onClick: _withModifiers(($event: any) => ($setup.deleteFilter(filter)), ["stop","prevent"])
                  }, _hoisted_13, 10 /* CLASS, PROPS */, _hoisted_11)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode($setup["TableauLink"], {
            style: _normalizeStyle({
            visibility: $setup.state.filters.length !== 0 ? 'visible' : 'hidden',
          }),
            onClick: _withModifiers($setup.addCurrentFilters, ["stop","prevent"]),
            disabled: $setup.advancedControlsDisabled || $setup.addingCurrentFilters,
            class: "double"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["style", "onClick", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", {
                class: _normalizeClass({ disabled: $setup.advancedControlsDisabled })
              }, "Iteration Filter: ", 2 /* CLASS */),
              (!$setup.state.iterationFilter)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Not Configured"))
                : _createCommentVNode("v-if", true),
              ($setup.state.iterationFilter)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["if", { disabled: $setup.advancedControlsDisabled }])
                  }, _toDisplayString($setup.state.iterationFilter.name) + " (" + _toDisplayString($setup.state.iterationFilter.values.length) + " value)", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["desc", { disabled: $setup.advancedControlsDisabled }])
            }, " Generate a new image/PDF for each value of the selected filter ", 2 /* CLASS */)
          ]),
          _createVNode($setup["TableauButton"], {
            class: "manage",
            text: "Manage",
            disabled: $setup.advancedControlsDisabled,
            color: "secondary",
            onClicked: _cache[4] || (_cache[4] = ($event: any) => ($setup.manageIterationFilter()))
          }, null, 8 /* PROPS */, ["disabled"])
        ]),
        _createElementVNode("label", {
          class: _normalizeClass({ disabled: $setup.advancedControlsDisabled })
        }, "Type of output:", 2 /* CLASS */),
        _createVNode($setup["TableauSelect"], {
          modelValue: $setup.state.outputType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.outputType) = $event)),
          disabled: $setup.advancedControlsDisabled,
          getItems: $setup.getOutputTypes
        }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
        _createElementVNode("label", {
          class: _normalizeClass({ disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf' })
        }, "PDF Page Orientation:", 2 /* CLASS */),
        _createVNode($setup["TableauSelect"], {
          modelValue: $setup.state.pageOrientation,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.pageOrientation) = $event)),
          disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf',
          getItems: $setup.getPageOrientations
        }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
        _createElementVNode("label", {
          class: _normalizeClass({ disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf' })
        }, "PDF Page Size:", 2 /* CLASS */),
        _createVNode($setup["TableauSelect"], {
          modelValue: $setup.state.pageSize,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.pageSize) = $event)),
          disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf',
          getItems: $setup.getPageSizes
        }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", {
            class: _normalizeClass({ disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf' })
          }, "Merge the PDF files created for each view:", 2 /* CLASS */),
          _createVNode($setup["TableauCheckBox"], {
            modelValue: $setup.state.mergePdfForViews,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.mergePdfForViews) = $event)),
            disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf'
          }, null, 8 /* PROPS */, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", {
            class: _normalizeClass({ disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf' })
          }, "Merge the PDF files created for each value of the iteration filter:", 2 /* CLASS */),
          _createVNode($setup["TableauCheckBox"], {
            modelValue: $setup.state.mergePdfForIterationFilter,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.mergePdfForIterationFilter) = $event)),
            disabled: $setup.advancedControlsDisabled || $setup.state.outputType[0] !== 'pdf'
          }, null, 8 /* PROPS */, ["modelValue", "disabled"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status", "statusMessage", "canSubmit", "statusLink"]))
}